import React from "react";
import { useLang } from "@/contexts/LanguageContext";

export default function Footer({ content }) {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();
  const fontH = lang === "ta" ? "font-serif-ta" : "font-serif-en";
  return (
    <footer data-testid="footer" className="bg-emerald-950 text-stone-200 pt-14 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full bg-amber-500 grid place-items-center text-emerald-950 font-serif-en text-xl">ن</div>
            <div>
              <div className={`${fontH} text-xl`}>{lang === "ta" ? "மஸ்ஜித் அல் நூர்" : "Masjid Al Noor"}</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-amber-200/80">Makkah Madrasa</div>
            </div>
          </div>
          <p className="text-sm text-stone-300/80 leading-relaxed">{content?.address}</p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-amber-300 mb-3">Quick Links</div>
          <ul className="space-y-2 text-sm">
            {["prayer", "announcements", "gallery", "events", "madrasa", "contact"].map((s) => (
              <li key={s}><a href={`#${s}`} className="hover:text-amber-300 transition-colors">{t(`nav_${s}`)}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-amber-300 mb-3">Connect</div>
          <p className="text-sm">{content?.phone}</p>
          <p className="text-sm">{content?.email}</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between text-xs text-stone-400 gap-2">
        <span>© {year} Masjid Al Noor Makkah Madrasa. {t("footer_rights")}</span>
        <span className="font-serif-en text-amber-300">بسم الله الرحمن الرحيم</span>
      </div>
    </footer>
  );
}
